import { FieldState } from '@angular/forms/signals';
import { input, Component, InputSignal, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.html',
  styleUrl: './form-field.scss',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'form-field',
    '[class.invalid]': 'fieldState()?.invalid() && fieldState()?.touched()',
  },
})
export class FormFieldComponent {
  public label: InputSignal<string | undefined> = input();

  public caption: InputSignal<string | undefined> = input();

  public fieldState = input<FieldState<string | number | [Date, Date] | boolean | null, string> | undefined>();
}
